export const offers = 'offers';
export const fibreSpeed = 'fibreSpeed';
export const optionFibreInternet15G = 'Fibre Internet';
export const fieldInstallation = 'fibreInstallation';
export const tenInternetBundleDiscount = '$10 Internet Bundle Discount';
export const twentyFiveInternetBundleDiscount = '$25 Internet Bundle Discount';
export const hundredBillCreditOnHSIA = '$100 Bill Credit on HSIA';
export const onePointFiveG = '1.5G';
export const threeG = '3G';
export const fieldServiceAddressNoteFibreVul = 'serviceAddressNoteFibreVul';

export const pricingFields = [offers, fibreSpeed, fieldInstallation];
